import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
const API_PREFIX_BUILD_MARKER = 'API_PREFIX_BUILD_MARKER_2026_03_24_v1';

/**
 * Prefixes all requests with `environment.host`.
 */
@Injectable()
export class ApiPrefixInterceptor implements HttpInterceptor {

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    console.log('[ApiPrefixInterceptor] build marker:', API_PREFIX_BUILD_MARKER, 'host:', environment.host);

    // If URL is already absolute, keep it unchanged.
    if (/^https?:\/\//i.test(request.url)) {
      console.log('[ApiPrefixInterceptor] absolute URL (unchanged):', request.url);
      return next.handle(request);
    }

    // Safely join host + relative path to avoid malformed URLs like xyzapi.
    const host = (environment.host || '').replace(/\/+$/, '');
    const path = (request.url || '').replace(/^\/+/, '');
    const finalUrl = `${host}/${path}`;
    console.log('[ApiPrefixInterceptor] joined URL:', { host, originalUrl: request.url, finalUrl });
    request = request.clone({ url: finalUrl });
    return next.handle(request);
  }

}
